import {
    RequestConfigFunction,
} from 'app/types/request.types'

type ChangeStatusToRejected = {
    rejectedReason: string,
    rejectedReasonComment: string,
}

type LaneFeesRequests = {
    domainName: string,
    update: RequestConfigFunction<{ laneFeesId: number }>,
    editableData: RequestConfigFunction<{ laneFeesId: number }>,
    getLaneFee: RequestConfigFunction<{ id: number }>,
    getInitialLaneFees: RequestConfigFunction<{ laneGroupId: number }>,
    duplicate: RequestConfigFunction<{ laneFeesId: number }>,
    archive: RequestConfigFunction<{ id: number }>,
    restore: RequestConfigFunction<{ id: number }>,
    cancellation: RequestConfigFunction<{ id: number }>,
    validity: RequestConfigFunction<{ id: number }>,
    awardedBulk: RequestConfigFunction<{ laneFees: { id: number }[] }>,
    rejectedBulk: RequestConfigFunction<{
        laneFees: { id: number }[],
        rejectedReason: string,
        rejectedReasonComment: string,
    }>,
    changeStatus: RequestConfigFunction<{
        id: number,
        status: string,
        data: ChangeStatusToRejected,
    }>,
    laneFeesFilterRequestAwardReject: RequestConfigFunction<{ params?: Record<string, any> }>,
    getAllowedFeeNames: RequestConfigFunction<undefined>,
    modifications: RequestConfigFunction<{ id: number }>,
    handoverData: RequestConfigFunction<{ id: number }>,
    filterRequestExpireSoon: RequestConfigFunction<{ params?: Record<string, any> }>,
    bulkCreate: RequestConfigFunction<{ data?: Record<string, any> }>
}

const laneFeesRequests: LaneFeesRequests = {
    domainName: 'LaneFees',
    update: ({
        laneFeesId,
    }) => {
        return {
            url: `lanefees/${laneFeesId}`,
            method: 'PATCH',
            domainName: 'LaneFees',
        }
    },
    editableData: ({
        laneFeesId,
    }) => {
        return {
            url: `lanefees/${laneFeesId}/editable-data`,
            method: 'PATCH',
            domainName: 'LaneFees',
        }
    },
    getLaneFee: ({
        id,
    }) => {
        return {
            url: `lanefees/${id}`,
            method: 'GET',
        }
    },
    getInitialLaneFees: ({
        laneGroupId,
    }) => {
        return {
            url: `lanefees/initialfees/all?laneGroupId=${laneGroupId}`,
            method: 'GET',
        }
    },
    duplicate: ({
        laneFeesId,
    }) => {
        return {
            url: `lanefees/${laneFeesId}/duplication`,
            method: 'POST',
            domainName: 'LaneFees',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `lanefees/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `lanefees/${id}/restore`,
            method: 'PATCH',
        }
    },
    cancellation: ({
        id,
    }) => {
        return {
            url: `lanefees/${id}/cancellation`,
            method: 'PATCH',
            domainName: 'LaneFees',
        }
    },
    validity: ({
        id,
    }) => {
        return {
            url: `lanefees/${id}/validity`,
            method: 'PATCH',
            domainName: 'LaneFees',
        }
    },
    awardedBulk: (data) => {
        return {
            url: 'lanefees/lanefeesstatus/awarded/bulk',
            method: 'PATCH',
            data,
        }
    },
    rejectedBulk: (data) => {
        return {
            url: 'lanefees/lanefeesstatus/rejected/bulk',
            method: 'PATCH',
            data,
        }
    },
    changeStatus: ({
        id,
        status,
        data,
    }) => {
        return {
            url: `lanefees/${id}/lanefeesstatus/${status}`,
            method: 'PATCH',
            data,
        }
    },
    laneFeesFilterRequestAwardReject: (params: Record<string, any> = {}) => {
        return {
            url: 'lanefees/filter-request/awardreject',
            method: 'POST',
            ...params?.params,
            data: {
                ...params?.data,
            },
        }
    },
    getAllowedFeeNames: () => {
        return {
            url: 'lanefees/feename/feechargeability/allowed',
            method: 'GET',
        }
    },
    modifications: ({
        id,
    }) => {
        return {
            url: `lanefees/${id}/modifications`,
            method: 'GET',
        }
    },
    handoverData: ({
        id,
    }) => {
        return {
            url: `lanefees/${id}/handover-data`,
            method: 'GET',
        }
    },
    filterRequestExpireSoon: (params: Record<string, any> = {}) => {
        return {
            url: 'lanefees/filter-request/expire-soon',
            method: 'POST',
            ...params?.params,
            data: {
                ...params?.data,
            },
        }
    },
    bulkCreate: ({
        data,
    } = {}) => {
        return {
            url: 'lanefees/bulk',
            method: 'POST',
            data,
        }
    },
}

export default laneFeesRequests
